webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/*
Accept a callback function that will recieve an instance of the api

Usage:
  prismic = require '@/services/prismic/api'
  module.exports =
    data: -> cms: null
    created: ->
      prismic (api) -> api.getSingle 'homepage'
      .then (response) => @cms = response.data
 */
var Prismic, endpoint;

Prismic = __webpack_require__(1);

endpoint = 'https://lightwaveconstruction.prismic.io/api/v2';

module.exports = function(cb) {
  return Prismic.getApi(endpoint).then(function(api) {
    return cb(api);
  });
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/*
DRY up Prismic code
 */
var Prismic, PrismicDOM;

Prismic = __webpack_require__(1);

PrismicDOM = __webpack_require__(2);

module.exports = {
  typeIs: function(type) {
    return Prismic.Predicates.at('document.type', type);
  },
  textOf: function(attribute) {
    return PrismicDOM.RichText.asText(attribute);
  }
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.db9e930.png";

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/*
Webpack has issues generating css source maps with scss files that are in the
same directory as entry js.  So this entry file dials out to modules in sub
directories to work around this.
 */
var Vue, inViewportDirective;

Vue = __webpack_require__(8);

inViewportDirective = __webpack_require__(12);

Vue.directive('in-viewport', inViewportDirective);

new Vue({
  el: '#app',
  render: function(create) {
    return create(__webpack_require__(14));
  }
});


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(15)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = __webpack_require__(17)
/* template */
var __vue_template__ = __webpack_require__(59)
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  components: {
    'navigation': __webpack_require__(18),
    'home': __webpack_require__(22),
    'site-footer': __webpack_require__(55)
  }
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(19)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = __webpack_require__(20)
/* template */
var __vue_template__ = __webpack_require__(21)
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = {
  data: function() {
    return {
      notAtTop: false,
      toggled: false
    };
  },
  created: function() {
    window.addEventListener('scroll', this.onScroll.bind(this), 500);
    return this.onScroll();
  },
  methods: {
    onScroll: function() {
      if ($(window).scrollTop() >= 400) {
        return this.notAtTop = true;
      } else {
        return this.notAtTop = false;
      }
    },
    anchorScroll: function(e) {
      var offsetPos, scrollTo, self;
      e.preventDefault();
      self = $(e.currentTarget);
      scrollTo = $('.' + self.data('target'));
      offsetPos = scrollTo.offset().top;
      $('html, body').animate({
        scrollTop: offsetPos
      }, 700);
      return this.toggled = false;
    },
    mobileToggle: function() {
      return this.toggled = !this.toggled;
    }
  }
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-in in-viewport",class:{'not-at-top': _vm.notAtTop},attrs:{"id":"navigation"}},[_vm._m(0,false,false),_c('div',{staticClass:"navigation"},[_c('a',{staticClass:"item",attrs:{"data-target":"what-we-do"},on:{"click":_vm.anchorScroll}},[_vm._v("What We Do")]),_c('a',{staticClass:"item",attrs:{"data-target":"about"},on:{"click":_vm.anchorScroll}},[_vm._v("About Us")]),_c('a',{staticClass:"item",attrs:{"data-target":"contact-us"},on:{"click":_vm.anchorScroll}},[_vm._v("Contact")])]),_c('div',{staticClass:"mobile-nav"},[_c('div',{staticClass:"toggle",class:{toggled: _vm.toggled},on:{"click":_vm.mobileToggle}}),_c('div',{staticClass:"dropdown",class:{toggled: _vm.toggled}},[_c('a',{staticClass:"item",attrs:{"data-target":"what-we-do"},on:{"click":_vm.anchorScroll}},[_vm._v("What We Do")]),_c('a',{staticClass:"item",attrs:{"data-target":"about"},on:{"click":_vm.anchorScroll}},[_vm._v("About Us")]),_c('a',{staticClass:"item",attrs:{"data-target":"contact-us"},on:{"click":_vm.anchorScroll}},[_vm._v("Contact")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(6)}})])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(23)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = __webpack_require__(24)
/* template */
var __vue_template__ = __webpack_require__(54)
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var Prismic, PrismicDOM, prismic, textOf;

Prismic = __webpack_require__(1);

prismic = __webpack_require__(4);

textOf = __webpack_require__(5).textOf;

PrismicDOM = __webpack_require__(2);

module.exports = {
  components: {
    'home-marquee': __webpack_require__(27),
    'clients': __webpack_require__(35),
    'what': __webpack_require__(39),
    'about': __webpack_require__(43),
    'contact': __webpack_require__(47)
  },
  data: function() {
    return {
      homeEls: null,
      clients: null,
      capabilities: null,
      people: null
    };
  },
  created: function() {
    this.getHomeEls();
    this.getClients();
    return this.getCapabilities();
  },
  methods: {
    getHomeEls: function() {
      return prismic((function(_this) {
        return function(api) {
          return api.getSingle('home');
        };
      })(this)).then((function(_this) {
        return function(response) {
          return _this.homeEls = response.data;
        };
      })(this));
    },
    getClients: function() {
      return prismic((function(_this) {
        return function(api) {
          return api.query(Prismic.Predicates.at('document.type', 'client')).then(function(response) {
            return _this.clients = response.results;
          });
        };
      })(this));
    },
    getCapabilities: function() {
      return prismic((function(_this) {
        return function(api) {
          return api.query(Prismic.Predicates.at('document.type', 'capability')).then(function(response) {
            return _this.capabilities = response.results;
          });
        };
      })(this));
    }
  }
};


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(28)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = __webpack_require__(29)
/* template */
var __vue_template__ = __webpack_require__(34)
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  components: {
    'next-block': __webpack_require__(30)
  },
  props: ['els']
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(31)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = __webpack_require__(32)
/* template */
var __vue_template__ = __webpack_require__(33)
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = {
  methods: {
    goNext: function() {
      return $('html, body').animate({
        scrollTop: $('.marquee').outerHeight() + 20
      }, 700);
    }
  }
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"next-block load-in in-viewport",on:{"click":_vm.goNext}},[_c('span',{staticClass:"icon-arrow-down"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }

/***/ }),
/* 34 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marquee load-in in-viewport"},[_c('div',{staticClass:"bkgd",style:({ 'background-image' : 'url(' + _vm.els.marquee_image.url + ')'})}),_c('div',{staticClass:"overlay"}),_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.els.title[0].text))]),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.els.subtitle[0].text))]),_c('next-block')],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(36)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = __webpack_require__(37)
/* template */
var __vue_template__ = __webpack_require__(38)
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = {
  props: ['clients']
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our-clients block-padding"},[_vm._m(0,false,false),_c('div',{staticClass:"clients"},_vm._l((_vm.clients),function(client){return _c('div',{staticClass:"client load-in in-viewport"},[_c('img',{attrs:{"src":client.data.icon.url}})])}))])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline load-in in-viewport"},[_c('h2',[_vm._v("Our Clients")])])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(40)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = __webpack_require__(41)
/* template */
var __vue_template__ = __webpack_require__(42)
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = {
  props: ['capabilities']
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-we-do"},[_vm._m(0,false,false),_vm._l((_vm.capabilities),function(capability){return _c('div',{staticClass:"service load-in in-viewport"},[_c('div',{staticClass:"bkgd",style:({ 'background-image' : 'url(' + capability.data.image.url + ')'})}),_c('div',{staticClass:"overlay"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"copy"},[_vm._v(_vm._s(capability.data.copy[0].text))])]),_c('div',{staticClass:"title-box"},[_c('h3',[_vm._v(_vm._s(capability.data.name[0].text))])])])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline load-in in-viewport"},[_c('h2',[_vm._v("What We Do")])])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(44)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = __webpack_require__(45)
/* template */
var __vue_template__ = __webpack_require__(46)
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var PrismicDOM, prismic, textOf;

prismic = __webpack_require__(4);

textOf = __webpack_require__(5).textOf;

PrismicDOM = __webpack_require__(2);

module.exports = {
  props: ['copy'],
  computed: {
    allCopy: function() {
      return PrismicDOM.RichText.asHtml(this.copy);
    }
  }
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about load-in block-padding in-viewport"},[_vm._m(0,false,false),_c('div',{staticClass:"copy",domProps:{"innerHTML":_vm._s(_vm.allCopy)}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline load-in in-viewport"},[_c('h2',[_vm._v("About Us")])])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = __webpack_require__(49)
/* template */
var __vue_template__ = __webpack_require__(52)
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a5a15af6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Prismic, PrismicDOM, _, prismic, textOf;

_ = __webpack_require__(50);

Prismic = __webpack_require__(1);

prismic = __webpack_require__(4);

textOf = __webpack_require__(5).textOf;

PrismicDOM = __webpack_require__(2);

module.exports = {
  data: function() {
    return {
      management: [],
      office: []
    };
  },
  mounted: function() {
    return this.getPeople();
  },
  methods: {
    getPeople: function() {
      return prismic((function(_this) {
        return function(api) {
          return api.query(Prismic.Predicates.at('document.type', 'contact')).then(function(response) {
            return _.each(response.results, function(person) {
              if (person.data.type === "Design/Build") {
                return _this.management.push(person);
              } else {
                return _this.office.push(person);
              }
            });
          });
        };
      })(this));
    }
  }
};


/***/ }),
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us load-in in-viewport block-padding"},[_vm._m(0,false,false),_c('div',{staticClass:"management half"},[_vm._m(1,false,false),_vm._l((_vm.management),function(manager){return _c('div',{staticClass:"contact load-in in-viewport"},[_c('div',{staticClass:"picture"},[_c('div',{staticClass:"bkgd",style:({ 'background-image' : 'url(' + manager.data.image.url + ')'})})]),_c('div',{staticClass:"info"},[_c('h3',[_vm._v(_vm._s(manager.data.name[0].text))]),_c('a',{staticClass:"email",attrs:{"href":("mailto:" + (manager.data.email[0].text))}},[_vm._v(_vm._s(manager.data.email[0].text))]),_c('div',{staticClass:"phone"},[_vm._v(_vm._s(manager.data.phone[0].text))])])])})],2),_c('div',{staticClass:"office half"},[_vm._m(2,false,false),_vm._l((_vm.office),function(contact){return _c('div',{staticClass:"contact load-in in-viewport"},[_c('div',{staticClass:"picture"},[_c('div',{staticClass:"bkgd",style:({ 'background-image' : 'url(' + contact.data.image.url + ')'})})]),_c('div',{staticClass:"info"},[_c('h3',[_vm._v(_vm._s(contact.data.name[0].text))]),_c('a',{staticClass:"email",attrs:{"href":("mailto:" + (contact.data.email[0].text))}},[_vm._v(_vm._s(contact.data.email[0].text))]),_c('div',{staticClass:"phone"},[_vm._v(_vm._s(contact.data.phone[0].text))])])])})],2),_vm._m(3,false,false)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline load-in in-viewport"},[_c('h2',[_vm._v("Contact Us")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"division"},[_c('h3',[_vm._v("Design\\Build Management")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"division"},[_c('h3',[_vm._v("Account\\Office Management")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socials"},[_c('div',{staticClass:"headline"},[_vm._v("Also see us on:")]),_c('a',{staticClass:"social",attrs:{"href":"https://www.instagram.com/lightwaveconstruction","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(53)}})])])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/instagram.0e84d59.png";

/***/ }),
/* 54 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-home"},[(_vm.homeEls)?_c('home-marquee',{attrs:{"els":_vm.homeEls}}):_vm._e(),(_vm.clients)?_c('clients',{attrs:{"clients":_vm.clients}}):_vm._e(),(_vm.capabilities)?_c('what',{attrs:{"capabilities":_vm.capabilities}}):_vm._e(),(_vm.homeEls)?_c('about',{attrs:{"copy":_vm.homeEls.about_copy}}):_vm._e(),_c('contact')],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(56)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = __webpack_require__(57)
/* template */
var __vue_template__ = __webpack_require__(58)
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {




/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-padding load-in in-viewport",attrs:{"id":"footer"}},[_c('div',{staticClass:"address"},[_c('p',[_vm._v("Lightwave Construction Inc.")]),_c('p',[_vm._v("5499 Daisy Dr.")]),_c('p',[_vm._v("Pollock Pines CA, 95726")]),_c('p',[_vm._v("530-344-7854 (office)")]),_c('p',[_vm._v("866-920-1143 (fax)")])]),_c('div',{staticClass:"copyright"},[_vm._v("Copyright 2017 Lightwave Construction Inc. CSLB# 1003659")]),_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(6)}})])])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }

/***/ }),
/* 59 */
/***/ (function(module, exports) {

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"in-viewport",rawName:"v-in-viewport.once",modifiers:{"once":true}}],attrs:{"id":"app"}},[_c('navigation'),_c('home'),_c('site-footer')],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }

/***/ })
],[7]);


// WEBPACK FOOTER //
// static/js/app.028805bd7a56ab7a8e71.js